import { add, compareAsc } from "date-fns";

export const generateTimes = (
  startTime: Date,
  endTime: Date,
  dates: Date[] = []
): Date[] => {
  if (compareAsc(startTime, endTime) !== -1) {
    dates.push(endTime);
    return dates;
  }

  dates.push(startTime);
  const nextTime = add(startTime, { hours: 1 });
  return generateTimes(nextTime, endTime, dates);
};
